<template>
  <van-field
    v-model="password"
    class="from-input password"
    :name="name"
    :label="label"
    :placeholder="placeholder"
    :maxlength="maxlength"
    :type="pwVisible ? `text` : `password`"
    :rules="
      rules
        ? [{ required, message: message || placeholder }, ...rules]
        : [{ required, message: message || placeholder }]
    "
    :formatter="(text?: string) => trim(text)"
  >
    <template #right-icon v-if="leftIcon">
      <svg-icon :icon-name="leftIcon" :width="46" current-color />
    </template>
    <template #button>
      <div class="flex-center" @click="pwVisible = !pwVisible">
        <van-icon class="right-icon" :name="pwVisible ? `eye-o` : `closed-eye`" current-color />
      </div>
    </template>
  </van-field>
</template>

<script setup lang="ts">
import { computed, defineModel, ref } from 'vue';
import { useI18n } from '@star/languages';
import { trim } from 'lodash-es';
import type { FieldRule } from 'vant';

type Props = {
  label?: string | number;
  placeholder?: string;
  name?: string;
  message?: string;
  maxlength?: number | string;
  leftIcon?: string;
  required?: boolean | 'auto';
  isOpen?: boolean;
  rules?: FieldRule[];
};

const props = withDefaults(defineProps<Props>(), {
  maxlength: 16,
  required: true,
  isOpen: false,
});

const { t } = useI18n();

const password = defineModel();
const pwVisible = ref<boolean>(props.isOpen);

const name = computed(() => {
  return props.name || 'password';
});

const label = computed(() => {
  return props.label ?? '支付密码';
});

const placeholder = computed(() => {
  return props.placeholder ?? '请输入您的支付密码';
});
</script>

<style lang="less" scoped>
.password {
  :deep(.right-icon) {
    color: #999;
    font-size: var(--van-field-icon-size);
  }
}
</style>
